import { FC } from 'react';
import { Button } from '@livechat/design-system-react-components';

import { CustomLink } from 'components/link/Link';

export const AlreadyHaveAnAccountLink: FC = () => (
  <CustomLink to="/">
    <Button kind="secondary" size="medium">
      Log in
    </Button>
  </CustomLink>
);
